export const pay_methods = [
  {"value": 1, "label": "cpa"},
  {"value": 2, "label": "cpl"},
  {"value": 3, "label": "crg"},
];
export const buy_methods = [
  {"value": 1, "label": "Buy"},
  {"value": 2, "label": "Resale"},
];